module.exports = __webpack_public_path__ + "img/tailwind.985366c.jpg";